<template>
  <div id="b-phone">
    <video
      playsinline
      autoplay
      loop
      muted
      poster="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Home+Page_Ge%CC%81ne%CC%81rique_Mobile_Couverture.jpg"
      class="home_video"
      @canplay="handleVideoPlay"
    >
      <source src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Home+Page_Ge%CC%81ne%CC%81rique_Mobile.mov">
    </video>
    <div class="video-overlay"></div>
    <div class="b-phone-container">
      <div class="b-phone-header">
        <h3 class="b-title merriweather-reg-30">{{ $t("Banner.header") }}</h3>
        <p class="b-content raleway-reg-p15">{{ $t("Banner.subtitle") }}</p>
      </div>
      <div>
        <MainSearchMobile></MainSearchMobile>
      </div>
    </div>
  </div>
</template>



<script>
import MainSearchMobile from "./btns/MainSearchMobile.vue";

export default {
  name: "b-phone",
  data() {
    return {
      isVideoPlaying: false, // Tracks if the video has started playing
    };
  },
  methods: {
    handleVideoPlay() {
      const video = this.$el.querySelector(".home_video");
      video.style.opacity = "1"; // Show video once it's ready
    },
    getLocation() {
      navigator.geolocation.getCurrentPosition((position) => {
        window.open(
          `/reservation-hotel?geo=${position.coords.latitude},${position.coords.longitude}`,
          "_blank"
        );
      });
    },
    animLogo(e) {
      e.currentTarget.animate(
        [
          { transform: "translateY(0px)" },
          { transform: "translateY(-10px)" },
          { transform: "translateY(0px)" },
        ],
        {
          duration: 800,
          easing: "ease-in-out",
          iterations: 2,
        }
      );
    },
  },
  components: { MainSearchMobile },
};
</script>

<style lang="scss" scope='app/assets/stylesheets/components/banner-phone'>
</style>
<style lang="scss" scoped>
.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 0;
  pointer-events: none;
}

.b-phone-container {
  position: relative;
  z-index: 2;
  overflow: visible;
}
</style>
